export const CATEGORY_CREATE_RESET = 'CATEGORY_CREATE_RESET'
export const CATEGORY_CREATE_SET_CREATED = 'CATEGORY_CREATE_SET_CREATED'
export const CATEGORY_CREATE_SET_ERROR = 'CATEGORY_CREATE_SET_ERROR'
export const CATEGORY_CREATE_SET_VIOLATIONS = 'CATEGORY_CREATE_SET_VIOLATIONS'
export const CATEGORY_CREATE_TOGGLE_LOADING = 'CATEGORY_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/category/create/mutation_types.js